export function getLogoaasUrl(_a) {
    var name = _a.name, size = _a.size, color = _a.color, first = _a.first, _b = _a.circle, circle = _b === void 0 ? false : _b, rebranding = _a.rebranding, _c = _a.single, single = _c === void 0 ? false : _c;
    var base = '//yastatic.net/q/logoaas/';
    if (rebranding)
        base += 'v2/';
    var circleParam = typeof circle === 'boolean' ? Number(circle) : circle;
    var singleParam = typeof single === 'boolean' ? Number(single) : single;
    return "" + base + name + ".svg?size=" + size + "&color=" + color + "&first=" + first + "&circle=" + circleParam + "&single=" + singleParam;
}
